<div class="form-header">
	<h2 class="ud-heading-xl">Notifications</h2>
	<p>Turn promotional email notifications from Udemy on or off</p>
</div>
<div class="um-container" style="margin-bottom:10px">
	<div class="ud-form-group">
		<label for="form-group--1" class="ud-form-label ud-heading-sm">
			I want to receive:
		</label>

		<div class="container">
			<form (ngSubmit)="onSubmit()">
				<div class="checkbox-box" style="padding-bottom:20px">
					<!-- style="height: 66px;" -->
					<label>
						<input type="checkbox" name="checkbox1" style="vertical-align: middle; margin-right:8px"
							[(ngModel)]="checkbox1Checked">Promotions, course recommendations, and helpful resources
						from Rvhost<br>
					</label>
				</div>
				<div class="checkbox-box">
					<label>

						<input type="checkbox" name="checkbox2" [(ngModel)]="checkbox2Checked">Announcements from
						instructors whose course(s) I’m enrolled in.<br>
						<p class="subtext" style=" font-size: 11px;margin-left: 23px; margin-right:8px">To adjust this
							preference by course, leave this box checked and go to the course dashboard and click on
							"Options" to opt in or out of specific announcements.</p>

					</label>
				</div>
				<div class="checkbox-box">
					<label>
						<input type="checkbox" name="checkbox3" [(ngModel)]="checkbox3Checked">
						Don't send me any promotional emails.<br>
						<p class="subtext" style=" font-size: 11px;margin-left: 23px;">If this box is checked, please
							note that you will continue to receive important transactional emails like purchase
							receipts.</p>

					</label>
				</div>
				<button type="submit" class="btn btn-primary">Submit</button>
			</form>
		</div>
	</div>
</div>